module.exports = __webpack_public_path__ + "media/images/logo-admin-85a04e2873641a5d162dc5eb41e4a38f.png";